<admin-panel-configurable [title]="'Technical Fields'">
  <admin-table-standard [items]="technicalFields">
    <ng-template #header>
      <th class="col-md-2" scope="col">{{ 'pages.channels.view.fields.name' | translate }}</th>
      <th class="col-md-7" scope="col">{{ 'pages.channels.view.fields.selectors' | translate }}</th>
      <th class="col-md-1" scope="col">{{ 'pages.channels.view.fields.type' | translate }}</th>
      <th class="col-md-1" scope="col">{{ 'pages.channels.view.fields.hash' | translate }}</th>
      <th class="col-md-1" scope="col">{{ 'pages.channels.view.fields.regex' | translate }}</th>
    </ng-template>
    <ng-template #first let-item>
      <td>{{ item.name }}</td>
      <td>{{ item.selector | json}}</td>
      <td>{{ ('common.text.data_type.' + item.dataType) | translate }}</td>
      <td>{{ item.hash }}</td>
      <td>{{ item.regex | json }}</td>
    </ng-template>
  </admin-table-standard>
</admin-panel-configurable>

<div class="pt-3"></div>

<admin-panel-standard [title]="'Physical Fields'" *ngIf="show(physicalFields)">
  <admin-table-standard [items]="physicalFields">
    <ng-template #header>
      <th class="col-md-2" scope="col">{{ 'pages.channels.view.fields.name' | translate }}</th>
      <th class="col-md-7" scope="col">{{ 'pages.channels.view.fields.selectors' | translate }}</th>
      <th class="col-md-3" scope="col">{{ 'pages.channels.view.fields.type' | translate }}</th>
    </ng-template>
    <ng-template #first let-item>
      <td>{{ item.name }}</td>
      <td>{{ item.selector | json }}</td>
      <td>{{ ('common.text.data_type.' + item.dataType) | translate }}</td>
    </ng-template>
  </admin-table-standard>
</admin-panel-standard>
